/**
 * node_modules
 */
// import type { PageProps } from "gatsby"
// import { graphql } from "gatsby"
import { Fragment } from "react/jsx-runtime"

/**
 * components
 */
import Layout from "@app/Layout"
import SEO from "@app/Seo"
// import { Heading } from "@components/Heading";
// import { Description } from "@components/Description";
import JsonLdForBreadcrumbList from "@app/JsonLdForBreadcrumbList"
import { Home } from "@features/Home"
import { Header } from "@components/Header"
import { Footer } from "@components/Footer"
import { SwitchHeaderColorProvider } from "@components/SwitchHeaderColorProvider"
import { ShadowTree } from "@src/components/ShadowTree"

const IndexPage = () => {
  return (
    <Fragment>
      <Layout>
        <SwitchHeaderColorProvider>
          <Header />
        </SwitchHeaderColorProvider>
        <Home />
      </Layout>
      <ShadowTree position="footer">
        <Footer />
      </ShadowTree>
    </Fragment>
  )
}

export default IndexPage

export const Head = () => (
  <SEO title={null} description={null} keywords={null} pathname={null}>
    <JsonLdForBreadcrumbList />
  </SEO>
)

/**
 * query
 */
// export const data = graphql`
//   query Camp {
//     camp {
//       title
//       url
//     }
//   }
// `
